var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-header"},[_c('portal',{attrs:{"to":"header"}},[_vm._t("header")],2),_vm._v(" "),_c('portal',{attrs:{"to":"header-aux"}},[_vm._t("aux")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }